import {Injectable} from '@angular/core';
import {BreakpointObserver} from '@angular/cdk/layout';
import {Observable} from 'rxjs';
import {map, shareReplay} from 'rxjs/operators';

// Keep these in sync with the breakpoint bands in src/_breakpoints.scss.
export const MOBILE_MAX_WIDTH = '(max-width: 599px)';
export const TABLET_MAX_WIDTH = '(max-width: 959px)';

@Injectable()
export class BreakpointService {

    // Emits true while the viewport is phone-sized (≤599px).
    readonly isMobile$: Observable<boolean>;

    // Emits true while the viewport is tablet-sized or smaller (≤959px).
    readonly isHandsetOrTablet$: Observable<boolean>;

    constructor(private breakpointObserver: BreakpointObserver) {
        this.isMobile$ = this.breakpointObserver
            .observe(MOBILE_MAX_WIDTH)
            .pipe(map(result => result.matches), shareReplay(1));

        this.isHandsetOrTablet$ = this.breakpointObserver
            .observe(TABLET_MAX_WIDTH)
            .pipe(map(result => result.matches), shareReplay(1));
    }
}
